<template>
  <div class="video-container content-bg" :class="{
    isMobile: isMobile()
  }">
    <commonTop
      :moduleData="moduleData"
    />
    
    <div 
      class="common-content-box sys-max-width"
    >
      <div class="content">
        <div class="top-cat flex justify-between items-center">
          <div>
            <el-tabs v-model="currentVideoCat" @tab-click="handleCatClick">
              <el-tab-pane :key="index" v-for="(item, index) in videoModuleList" :label="item.name" :name="item.id"></el-tab-pane>
            </el-tabs>
          </div>

          <div class="search-box flex-shrink-0 flex items-center">
            <div class="axt-logo" @click="goAxtLink"></div>

            <el-input
              clearable
              placeholder="请输入课程名"
              prefix-icon="el-icon-search"
              @input="searchInputHandle"
              v-model="searchVal">
            </el-input>
          </div>
        </div>

        <!-- 二级分类 -->
        <div v-if="!searchVal && secVideoModuleList" class="video-cat-box grid lg-mx lg:grid-cols-4 md:grid-cols-4 grid-cols-1 gap-8">
          <videoItem 
            v-for="(item, index) in secVideoModuleList"
            :key="index"
            :item="item"
            @click="goSec"
          />
        </div>

        <!-- 视频 -->
        <div v-if="!searchVal && !secVideoModuleList" class="video-box grid lg-mx lg:grid-cols-4 md:grid-cols-4 grid-cols-1 gap-8">
          <videoItem 
            v-for="(item, index) in videoList"
            :key="index"
            :item="item"
            @click="goDetail"
          />
        </div>

        <!-- 搜索视频 -->
        <div v-if=" searchVal" class="video-box grid lg-mx lg:grid-cols-4 md:grid-cols-4 grid-cols-1 gap-8">
          <videoItem 
            v-for="(item, index) in searchList"
            :key="index"
            :item="item"
            @click="goDetail"
          />
        </div>
      </div>

      <!-- 分页 -->
      <div v-if="!searchVal && !secVideoModuleList && (currentVideoCat !== HOTVIDEOID)" class="page text-center">
        <el-pagination
          background
          @current-change="currentPageChange"
          :current-page.sync="page"
          :page-size="pageSize"
          layout="prev, pager, next"
          :total="total">
        </el-pagination>
      </div>
    </div>
  </div>
</template>

<script>
/* eslint-disable */
import { fetchAllVideoList, fetchVideoCate, fetchHotVideoList, fetchVideoByKeys } from '@/api/video'
import { MODULE_CONFIG } from '@/config/index'
import moduleMixins from '@/mixins/module'
import pageMixins from '@/mixins/page'
import { isMobile } from '@/utils/index'
import videoItem from '@/components/videoItem'

export default {
  mixins: [moduleMixins, pageMixins],
  components: {
    videoItem
  },
  data() {
    return {
      moduleId: MODULE_CONFIG.VIDEO,

      searchVal: '',

      HOTVIDEOID: '-1', 
      currentVideoCat: '',
      videoModuleList: [], // 视频分类

      videoList: [], // 视频列表

      searchList: [],

      pageSize: 16
    }
  },
  computed: {
    secVideoModuleList() { // 二级分类
      const firstModuleItem = this.videoModuleList.find(item => item.id === this.currentVideoCat)

      if (firstModuleItem) {
        const child = firstModuleItem.children

        return Array.isArray(child) ? child : null
      } else {
        return null
      }
    }
  },
  watch: {
    currentVideoCat(newVal) {
      this.searchVal = ''

      if (newVal === '0') {
        return
      }

      // 重置页码
      this.page = 1

      if (this.currentVideoCat === this.HOTVIDEOID) { // 热门视频
        this.getHotContentList()
      } else { // 其他模块
        if (!this.secVideoModuleList) { // 没有二级模块，加载视频
          this.getCommonContentList()
        }
      }
    }
  },
  methods: {
    isMobile,

    goAxtLink() {
      window.open(`${window.location.origin}#/layout/axt`)
    },

    async searchInputHandle() {
      console.log(this.searchVal)

      if (!this.searchVal) {
        this.searchList = []
        return
      }

      try {
        const { list } = await fetchVideoByKeys({
          title: this.searchVal,
          page: 1,
          pageSize: 999
        })

        this.searchList = list

      } catch (error) {
        
      }
    },

    currentPageChange(e) {
      this.page = e

      this.getCommonContentList()

      // 滚动到顶部
      document.body.scrollTop = document.documentElement.scrollTop = 0
    },

    handleCatClick(e) {
      console.log(e)

      this.$router.push({
        query: {
          id: this.currentVideoCat
        }
      })
    },

    goSec(item) {
      this.$router.push({
        name: 'video-sec',
        query: {
          id: this.currentVideoCat,
          secId: item.id
        }
      })
    },

    goDetail(item) {
      console.log(item)
      this.$router.push({
        name: 'videoDetail',
        query: {
          id: item.id,
          video_code: item.video_code
        }
      })
    },

    async getHotContentList() {
      try {
        this.videoList = await fetchHotVideoList({
          count: 12
        })
      } catch (error) {
        
      }
    },

    async getCommonContentList() {
      try {
        const { list, total } = await fetchAllVideoList({
          page: this.page,
          pageSize: this.pageSize,
          category_id: this.currentVideoCat
        })

        this.videoList = list
        this.total = Number(total)
      } catch (error) {
        
      }
    },

    async getVideoModule() {
      try {
        const data = await fetchVideoCate()

        this.videoModuleList = [
          {
            id: this.HOTVIDEOID,
            name: '热门视频'
          },
          ...data
        ]

        const { id } = this.$route.query
        this.currentVideoCat = id ? id : this.videoModuleList[0].id
      } catch (error) {
        
      }
    }

  },
  created() {


    this.getVideoModule()
  }
}
</script>

<style lang="scss">
.video-container {
  // &.isMobile {
  //   .video-item {
  //     .img {
  //       height: 195px;
  //     }
  //   }
  // }

  .search-box {
    .axt-logo {
      width: 100px;
      height: 33px;
      background: url(~@/assets/axt-logo.png) no-repeat;
      background-size: 100% 100%;
      margin-right: 10px;
      cursor: pointer;
    }
  }

  .video-hot-box {
    margin-bottom: 53px;
  }

  .video-box {
    margin-bottom: 53px;
  }

  .content {
    .top-cat {
      margin-bottom: 30px;

      .el-tabs  {
        .el-tabs__header {
          margin-bottom: 0;
        }

        .el-tabs__item {
          font-size: 16px;
          color: #545c63;
          font-weight: 700;
        }

        .el-tabs__nav-wrap::after {
          display: none;
        }
      }
    }
  }
}
</style>